import React, { forwardRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';

export interface GenericCalendarProps<T = any> {
	events: T[];
	initialView?: string;
	headerToolbar?: CalendarOptions['headerToolbar'] | false;
	eventContent?: CalendarOptions['eventContent'];
	eventClick?: CalendarOptions['eventClick'];
	dateClick?: CalendarOptions['dateClick'];
	height?: string | number;
	editable?: boolean;
	selectable?: boolean;
	customOptions?: Partial<CalendarOptions>;
	calendarRef?: React.Ref<any>;
}

export const Calendar = forwardRef<any, GenericCalendarProps<any>>(
	(
		{
			events,
			initialView = 'dayGridMonth',
			headerToolbar = false,
			eventContent,
			eventClick,
			height = 'auto',
			editable = false,
			selectable = false,
			customOptions = {},
			calendarRef,
			dateClick,
		},
		ref,
	) => {
		return (
			<FullCalendar
				ref={calendarRef || ref}
				plugins={[dayGridPlugin, interactionPlugin, listPlugin, timeGridPlugin]}
				initialView={initialView}
				headerToolbar={headerToolbar}
				events={events}
				eventContent={eventContent}
				eventClick={eventClick}
				dateClick={dateClick}
				height={height}
				editable={editable}
				selectable={selectable}
				{...customOptions}
			/>
		);
	},
);

Calendar.displayName = 'Calendar';
